// Single source of truth for the "% remaining" scarcity number shown on /tickets
// (GA badge, Last Call timeline, checkout urgency bar).
// Step-down plan (Teddy, 2026-07-06): 15 → 12 → 5 as inventory moves.
// Update this one number and redeploy — nothing else to touch.
export const REMAINING_PCT = 15;
